module.exports = __webpack_public_path__ + "img/my-message.85219772.png";